import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Container } from '../../../ui/gridSystem';
import { CTA, Icon, Text } from '../../../ui/atoms';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { MODAL_OPEN } from '../../redux/actions';
import { COURSE_CANCEL } from '../../redux/actions/tutors';
import ModalCancelCourse, {
  ModalCancelCourseId,
} from '../../../ui/atoms/Modals/ModalCancelCourse';
import { Card, CardsWrapper, IconWrapper } from './style';
import routes from '../../../routes';

const ChooseCourseType = ({ mediaIsPhone, modalOpen }) => {
  const navigate = useNavigate();
  return (
    <Container>
      <div className={mediaIsPhone ? '' : 'd-flex sb'}>
        <Text type="h1" mb={mediaIsPhone ? 8 : 0}>
          Creazione percorso formativo
        </Text>
        <CTA
          type="tertiary"
          btnText="ESCI DALLA MODALITà DI CREAZIONE"
          onClick={() => modalOpen(ModalCancelCourseId)}
          icon="x-close"
        />
      </div>
      <Text type="h1.5" mt={40} mb={8}>
        Seleziona la tipologia
      </Text>
      <Text type="b3" mb={48}>
        Seleziona la tipologia di percorso formativo da creare:
      </Text>
      <CardsWrapper className="d-flex sb">
        <Card>
          {!mediaIsPhone && (
            <IconWrapper>
              <Icon
                type="graduation-hat-02"
                size={40}
                clickable={false}
                strokeWidth={1.5}
              />
            </IconWrapper>
          )}
          <div>
            <div className="d-flex g-24">
              {mediaIsPhone && (
                <IconWrapper>
                  <Icon
                    type="graduation-hat-02"
                    size={26}
                    clickable={false}
                    strokeWidth={1.5}
                  />
                </IconWrapper>
              )}
              <Text type="h2">Corso</Text>
            </div>
            <Text type="b3" mt={8} mb={24}>
              Crea un corso completo che includa una serie di attività
              interattive, moduli e video didattici, esercizi pratici, documenti
              da leggere e quiz di valutazione.
            </Text>
            <CTA
              btnText="Crea corso"
              fullsize={mediaIsPhone}
              bottomRight
              onClick={() => navigate(routes.createCourse.path)}
            />
          </div>
        </Card>
        <Card>
          {!mediaIsPhone && (
            <IconWrapper>
              <Icon
                type="calendar-date"
                size={40}
                clickable={false}
                strokeWidth={1.5}
              />
            </IconWrapper>
          )}
          <div>
            <div className="d-flex g-24">
              {mediaIsPhone && (
                <IconWrapper>
                  <Icon
                    type="calendar-date"
                    size={26}
                    clickable={false}
                    strokeWidth={1.5}
                  />
                </IconWrapper>
              )}
              <Text type="h2">Evento</Text>
            </div>
            <Text type="b3" mt={8} mb={24}>
              Crea un evento per coinvolgere i partecipanti in una esperienza
              interattiva di apprendimento, includendo sessioni di formazione e
              quiz di valutazione.
            </Text>
            <CTA
              btnText="Crea evento"
              fullsize={mediaIsPhone}
              bottomRight
              onClick={() => navigate(routes.createEvent.path)}
            />
          </div>
        </Card>
      </CardsWrapper>
      <ModalCancelCourse />
    </Container>
  );
};

ChooseCourseType.propTypes = {
  mediaIsPhone: PropTypes.bool,
  modalOpen: PropTypes.func,
};

export default connect(
  (state) => {
    return {};
  },
  (dispatch) => ({
    modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
    courseCancel: () => dispatch({ type: COURSE_CANCEL._REQUEST }),
  })
)(withMediaQueries(ChooseCourseType));
